import { SEARCH_QUERY_PARAM_NAME } from "src/constants/UrlConstants";
import { CustomGridSummaryDto, CustomUniverseDto } from "src/hooks/Utils/universe";
import { ROUTE_PATHS } from "./constants";

const space = /\s+/gi;
const categoryUrlRegex = /.*-l([0-9]+)/;

export const encodePathFragment = (fragment: string) => encodeURIComponent(fragment?.replace(space, '-'));

export const getCategoryUrl = (universe: CustomUniverseDto, grid: CustomGridSummaryDto) => 
    `${ROUTE_PATHS.PRODUCTS}/${encodePathFragment(universe?.name)}-l${universe?.id}/${encodePathFragment(grid?.name)}-l${grid?.id}`;

export const getSubCategoryUrl = (universe: CustomUniverseDto, grid: CustomGridSummaryDto, subGrid: CustomGridSummaryDto) => 
    `${ROUTE_PATHS.PRODUCTS}/${encodePathFragment(universe?.name)}-l${universe?.id}/${encodePathFragment(grid?.name)}-l${grid?.id}/${encodePathFragment(subGrid?.name)}-l${subGrid?.id}`;

export const getURLFragmentId = (paramId: string) => {
   if (categoryUrlRegex.exec(paramId)?.length >= 1) {
       return categoryUrlRegex.exec(paramId)[1];
   }
   return null
};

const encodeSearchPathFragment = (fragment: string) => encodeURIComponent(fragment);

export const setSearchUrl = (universe: CustomUniverseDto, searchQueryParam: string) => {
    const asd = /\-/gi;
    const sufix = searchQueryParam ? `?${SEARCH_QUERY_PARAM_NAME}=${encodeSearchPathFragment(searchQueryParam)}` : "";
    return `${ROUTE_PATHS.SEARCH}/${encodePathFragment(universe?.name)}${sufix}`;
};